import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function onboard(data) {
    var url = process.env.REACT_APP_API_BASE_URL + `/onboard`;
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}
